import { useEffect, useState } from "react";
import { getContent } from "@/lib/api";

export function useContent() {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;
    getContent()
      .then((data) => mounted && setContent(data))
      .catch((e) => mounted && setError(e))
      .finally(() => mounted && setLoading(false));
    return () => {
      mounted = false;
    };
  }, []);

  return { content, loading, error };
}
